import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../lib/styles/props/component-style-props";
import React from "react";
import { CMSearchResultCellFrame } from "../CMSearchResultCellFrame/CMSearchResultCellFrame";
import {
  ComponentMultiStyleConfig,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import { CMDatetimeText } from "../../../text";

export type CMSearchResultCellDatetimeProps = {
  value?: Date;
} & ComponentStyleProps;

export const CMSearchResultCellDatetime = ({
  value,

  sx,
  ...rest
}: CMSearchResultCellDatetimeProps) => {
  const styles = useMultiStyleConfig("CMSearchResultCellDatetimeStyles");

  return (
    <CMSearchResultCellFrame sx={{ ...styles.container, ...sx }} {...rest}>
      <CMDatetimeText value={value} sx={styles.content} />
    </CMSearchResultCellFrame>
  );
};

export const CMSearchResultCellDatetimeStyles: ComponentMultiStyleConfig = {
  parts: ["container", "content"],
  baseStyle: {
    container: {},
    content: {},
  },
};
